<div class="residential-insured-details__section-row">
  <span class="residential-insured-details__section-title">
    {{ 'residential.additional_insured_detail' | translate }}
  </span>
  <span class="residential-insured-details__section-step">{{index + 1}} out of {{totalAdditionalInsured}}</span>
  <button mat-button (click)="onRemoveInsured()">
    <mat-icon>remove</mat-icon>
    <span>{{'residential.remove_insured_button' | translate}}</span>
  </button>
</div>
<form *ngIf="form" [formGroup]="form" fxLayout="column">
  <div fxLayout="row" fxFlex="100%" style="margin-bottom: 15px;">
    <mat-checkbox formControlName="spouse" (change)="spouseChanged.emit($event)">{{'residential.spouse' | translate}}</mat-checkbox>
  </div>
  <div class="inline-input-items" fxLayout="row" fxLayoutGap="10px" style="margin-bottom: 15px; height: 100%">
    <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%"  appearance="outline">
      <mat-label>{{'form.first_name' | translate}}</mat-label>
      <input matInput type="text" formControlName="first_name">
      <mat-error *ngIf="f['first_name'].errors" class="invalid-input-dedactible">
        {{ f['first_name'] | errorMsg }}
      </mat-error>
    </mat-form-field>
    <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%"  appearance="outline">
      <mat-label>{{'user.middle_name' | translate}}</mat-label>
      <input matInput type="text" formControlName="middle_name">
      <mat-error *ngIf="f['middle_name'].errors" class="invalid-input-dedactible">
        {{ f['middle_name'] | errorMsg }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="inline-input-items" fxLayout="row" fxLayoutGap="10px" style="margin-bottom: 15px; height: 100%">
    <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
      <mat-label>{{'form.last_name' | translate}}</mat-label>
      <input matInput type="text" formControlName="last_name">
      <mat-error *ngIf="f['last_name'].errors" class="invalid-input-dedactible">
        {{ f['last_name'] | errorMsg }}
      </mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="50%" fxFlex.lt-sm="100%" appearance="outline">
      <mat-label>{{ 'residential.email_address' | translate }}</mat-label>
      <input matInput type="text" formControlName="email">
      <mat-error *ngIf="f['email'].errors">
        <ng-container *ngIf="f['email'].errors">
          {{ f['email'] | errorMsg }}
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>

  <mat-form-field fxFlex="100%" appearance="outline">
    <mat-label>{{ 'user.birth_date' | translate }}</mat-label>
    <input matInput formControlName="birth_date_sub" type="text"
           (ngModelChange)="createResidentialLead('birth_date_sub')"
           [max]="maxBirthdayDate"
           [matDatepicker]="picker_expiration_date_sub">
    <mat-datepicker-toggle matSuffix [for]="picker_expiration_date_sub"></mat-datepicker-toggle>
    <mat-datepicker #picker_expiration_date_sub></mat-datepicker>
    <mat-error *ngIf="f['birth_date_sub'].errors">
      {{ f['birth_date_sub'] | errorMsg: ('user.birth_date' | translate) }}
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="100%" appearance="outline" style="height: 100%">
    <mat-label>{{ 'residential.contact_phone' | translate }}</mat-label>
    <input matInput type="text" formControlName="contact_phone" mask="(000) 000-0000">
    <mat-error *ngIf="f['contact_phone'].errors">
      {{ f['contact_phone'] | errorMsg: ('residential.contact_phone' | translate) : 'phone' }}
    </mat-error>
  </mat-form-field>
</form>
